var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"596eb61e657c006ac31e2b2001af7ab12a1e4d2a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["supabase-app@supabase"]={id:"596eb61e657c006ac31e2b2001af7ab12a1e4d2a"};
      